import { NgModule } from '@angular/core';
import { ImageAsyncComponent } from './image-async.component';

@NgModule({
  declarations: [
    ImageAsyncComponent
  ],
  exports: [ImageAsyncComponent]
})
export class ImageAsyncModule { }
